import ReassuranceItems from './ReassuranceItems.vue'

export default ReassuranceItems
